/**
 * Click-to-open "?" tooltip used throughout the report builder.
 *
 * Extracted from ReportBuilderWizard so the wizard and the filter panel can
 * share one implementation without importing from the route component.
 */
import { useEffect, useRef, useState } from 'react';

export function HelpTip({ text }: { text: string }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <span ref={ref} className="relative ml-1 inline-flex">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-slate-200 text-[10px] font-bold leading-none text-slate-600 hover:bg-slate-300"
        aria-label="Help"
      >
        ?
      </button>
      {open && (
        <span className="absolute bottom-full left-0 z-50 mb-2 w-64 rounded-md bg-slate-800 px-3 py-2 text-xs font-normal leading-relaxed text-white shadow-lg">
          {text}
          <span className="absolute left-2 top-full border-4 border-transparent border-t-slate-800" />
        </span>
      )}
    </span>
  );
}
